import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination,EffectCoverflow } from "swiper";
import art5 from "assets/images/compressed/Coot07.jpg"
import art6 from "assets/images/compressed/Coot021.jpg"
import art7 from "assets/images/compressed/Coot026.jpg"
import art9 from "assets/images/compressed/Cootie (29).jpg"
import art10 from "assets/images/compressed/Cootie (173).jpg"
import art11 from "assets/images/compressed/Cootie (175).jpg"
import art12 from "assets/images/compressed/Cootie (260).jpg"
import art13 from "assets/images/compressed/Cootie (1587).jpg"
import art14 from "assets/images/compressed/Cootie (1588).jpg"
import art15 from "assets/images/compressed/Cootie (1609).jpg"
import art16 from "assets/images/compressed/Cootie (2020).jpg"
import art17 from "assets/images/compressed/Cootie (2031).jpg"
import art19 from "assets/images/compressed/Cootie (2191).jpg"
import art20 from "assets/images/compressed/Cootie (2242).jpg"
import art21 from "assets/images/compressed/Cootie (2686).jpg"
import Thecooties from "assets/images/others/logo1.png"
SwiperCore.use([Autoplay, Pagination]);

const NftSlider = () => {
    const images = [
        { img: art5, },
        { img: art6,  },
        { img: art7, },
        { img: art9, },
        { img: art10,  },
        { img: art11, },
        { img: art12,},
        { img: art13,  },
        { img: art14,  },
        { img: art15, },
        { img: art16,},
        { img: art17,  },
        { img: art19,  },
        { img: art20,  },
        { img: art21,  },
    ];

    return (
        <section id="nft">
            <div className="sec-heading-wrapper">
                {/* <h2 data-aos="fade-down" className="sec-heading">
               The Cooties
                </h2> */}
                <img className="nftSlider-heading-img" src={Thecooties} alt="" />
            </div>
            <Swiper
                autoplay={{ disableOnInteraction: false, delay: 1500 }}
                className="nft-slide-container"
                speed={500}
                effect="coverflow"
                initialSlide={2}
                pagination={{ clickable: true }}
                spaceBetween={75}
                centerInsufficientSlides
                slidesPerView={3}
                centeredSlides
                loop={true}
                breakpoints={{
                    190: {
                        slidesPerView: 1,
                        spaceBetween: 15
                    },
                    320: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    992: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                    1500: {
                        slidesPerView: 4,
                    },
                    1800: {
                        slidesPerView: 5,
                    },
                    2200: {
                        slidesPerView: 5,
                    },
                    2800: {
                        slidesPerView: 6,
                    },
                }}
            >
                {images.map((imgItem, index) => (
                    <SwiperSlide key={index} className="nft-slide">
                        {imgItem.anchor ?
                            <a className="article-link" href={imgItem.link} target="_blank" rel="noopener noreferrer">
                                <img className="nft-art-img" src={imgItem.img} alt="Mutant-Mingos" />
                            </a>
                            : <img className="nft-art-img" src={imgItem.img} alt="Mutant-Mingos" />}
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    )
}

export default NftSlider
